import { Action, SubjectRoles } from "@/api-schema-enums";
import { AppAbility } from "@/casl-provider";
import { User } from "@/store/user-store";
import { AbilityBuilder } from "@casl/ability";

export function setJobFunctionPermissions(user: User, builder: AbilityBuilder<AppAbility>) {
  const { can } = builder;

  if (!user.roles.includes(SubjectRoles.Int)) {
    return;
  }

  can(Action.Read, "JobFunction");

  if (user.roles.includes(SubjectRoles.MasterdataAdministrator)) {
    can(Action.Manage, "JobFunction");
  }
}
